<template>
  <div v-if="product" class="videos" :class="{ 'mb-12': !product.videoOnly }">
    <div v-if="product.videoOnly" class="videos__only">
      <div :style="{ padding: `${product.ratio} 0 0 0`, position: 'relative' }">
        <iframe
          :src="product.embedUrl"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
          :title="product.videoTitle"
        ></iframe>
      </div>
    </div>

    <div v-else class="container page mt-4 mt-md-12">
      <div class="text-center mb-4 white pa-8 rounded-lg">
        <v-img
          :src="product.image"
          max-width="400"
          class="rounded-lg ma-auto"
        />
      </div>

      <div class="text-h6 mb-4">
        {{ product.title }}
      </div>

      <div :style="{ padding: `${product.ratio} 0 0 0`, position: 'relative' }">
        <iframe
          :src="product.embedUrl"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
          :title="product.videoTitle"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Products from "./Products.json";

export default {
  name: "Videos",
  data() {
    return {
      products: Products,
    };
  },

  computed: {
    product() {
      const p = this.products.find(
        (product) => product.hash === this.$route.params.id
      );

      if (!p) {
        return null;
      } else {
        return p;
      }
    },
  },

  mounted() {
    if (!this.product) {
      this.$router.push({ path: "/404" });
    }
  },
};
</script>

<style lang="scss" scoped>
.videos__only {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
</style>
